import React, { useState } from "react";
import { getContainer } from "../../ioc/IOCSetup";
import { AccountRole, Product, TransferRequest, TransferRequestSubtype, TransferRequestType } from "../../http/protocol";
import { Form, FormListener } from "../form/Form";
import { FormGroup } from "../form/FormGroup";
import { Submit } from "../form/Submit";
import { UserActionContainerProps, UserActionContainer, UpdateActionStatus } from "./UserActionContainer";
import { WalletService } from "../../services/WalletService";

export const UserDormantCollection: React.FC<UserActionContainerProps> = (props: UserActionContainerProps) => {

    const walletService : WalletService =getContainer().getWalletService(); 
    const [form, setForm] = useState<{[product:string]: Product | undefined}>({ product: undefined });
    const [error, setError] = useState("");

    function submit() {
        let users = [...props.users || []];
        users.forEach(user=>{
            try {
                user.status = UpdateActionStatus.PENDING;
                user.description = "Prepared to set balance to 0";
                user.request = () => new Promise<{ status: UpdateActionStatus; description: string; response: any; }>(async (resolve, reject) => {
                    walletService.getAccountBalances(user.id.toString())
                    .then((accountBalance) => {
                        //Get account balances where the account attributes have a role named MAIN
                        let filterBalanceMain = accountBalance.filter(x=>x.balance && x.balance.currencyCode==="mBTC" && x.accountAttributes && x.accountAttributes["ROLE"]===AccountRole.MAIN);
                        //For all account balances
                        filterBalanceMain.forEach(mainBalance=>{
                            //get balance
                            let balance =  mainBalance.balance;
                            if(balance===undefined || balance===null){
                                resolve({ status: UpdateActionStatus.FAIL, description: "An error has occurred obtaining the account balance null or undefined", response: error });
                            }else{
                                // validate different amount not undefined and greater equal zero
                                let amount = balance.amount;
                                if(amount === undefined || amount===null || amount===0){
                                    resolve({ status: UpdateActionStatus.FAIL, description: "An error has occurred with the amount from account balance is null or undefined or zero", response: error });
                                }else{
                                    if(amount>0){
                                        let transferRequest: TransferRequest = {};
                                        transferRequest.type = TransferRequestType.DEBIT;
                                        transferRequest.subtype = TransferRequestSubtype.COLLECTION;
                                        transferRequest.comment = "Dormant account with more than 12 months inactive. Balance seized, please check balance movements for mBTC amount, closed (products disabled). If user contacts and wants to reopen account, escalate to Management for review.";
                                        transferRequest.amount =   Number(amount);
                                        transferRequest.accountId = Number(mainBalance.accountId);
                                        walletService.transfer(transferRequest)
                                        .then((tr)=>{
                                            resolve({ status: UpdateActionStatus.OK, description: "Set balance to 0", response: tr });
                                        }).catch(err=>{
                                            resolve({ status: UpdateActionStatus.FAIL, description: "An error has occurred in the account balance making the debit", response: err });
                                        });
                                    }
                                }
                            }
                        })

                    }).catch((error) => {
                        resolve({ status: UpdateActionStatus.FAIL, description: "An error has occurred obtaining the account balance", response: error });
                    });
                })
            } catch (error) {
                user.status = UpdateActionStatus.FAIL;
                user.description = "General Error process not completed: "+error;       
            }
        })

        if (props.updateUsers) props.updateUsers(users);
    }

    const ref: FormListener<any> = {
        formDidUpdate: (formModel: any, validationMap: any) => {
            setForm(formModel);
        },
        onSubmit: () => {
            submit();
        }
    };

    return (
        <UserActionContainer title={"User Dormant Collections"}>
            <Form className="form-horizontal" formListener={ref} modelObject={form} validationMap={{}}>
                <FormGroup className="form-group row">
                    <div className="col-sm-4">
                    <Submit className="btn btn-danger" onClick={(e) => { e.preventDefault(); submit(); }}>Submit
                    </Submit>
                    </div>
                </FormGroup>
                <FormGroup className="form-group row">
                    <span className={"help-block"}>The balance will be adjusted to 0 and the comment will be marked as a dormant action for the chosen users.</span>
                </FormGroup>
            </Form>
        </UserActionContainer>
    );
}